import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";
import {IExtractImageModel} from "../types/manualFinder";
import aws_config from '../modified_aws-export';
import {submitImageFeedback} from "../services/manualFinder/submitImageFeedback";

export const useFeedbackHandler = (
    parentImages: IExtractImageModel[],
    setParentImages: (parentImages: IExtractImageModel[]) => void) => {
    const {t} = useTranslation();

    const handleFeedback = async (isUseful: boolean, id: any) => {
        const index = parentImages.findIndex((image: any) => image.parentFile.id === id);
        if (index !== -1) {
            const isSuccess = await submitImageFeedback(
                parentImages[index].parentFile.id,
                aws_config.aws_user_files_s3_bucket,
                parentImages[index].parentKeyName,
                isUseful
            );

            if (isSuccess) {
                const updatedImages = [...parentImages];
                updatedImages[index].isUseful = isUseful;
                updatedImages[index].feedbackProvided = true;
                updatedImages.sort((a, b) => {
                    if (a.isUseful === b.isUseful) return 0;
                    if (a.isUseful === true) return -1;
                    if (b.isUseful === true) return 1;
                    if (a.isUseful === null) return -1;
                    if (b.isUseful === null) return 1;
                    return 0;
                })
                setParentImages(updatedImages);
                toast(t("ExtractedImages.FeedbackSubmitted"), {type: "success"});
            } else {
                toast(t("ExtractedImages.FeedbackSubmittedError"), {type: "error"});
            }
        }
    };

    return {handleFeedback};
};
